import "./MenuOverlay.scss";
import { useEffect, useState } from "react";
import cn from "classnames";
import { HideFor } from "/App.Components";

export interface Props {
  showMobile: boolean;
  showDesktop: boolean;
}

const MenuOverlay = ({ showMobile, showDesktop }: Props) => {
  const [initialized, setInitialized] = useState(false);
  useEffect(() => setInitialized(true), []);
  return (
    <>
      <HideFor mobile tablet>
        <div
          className={cn("menu-overlay-norad", {
            "menu-overlay-norad--show": showDesktop,
            "menu-overlay-norad--initialized": initialized,
          })}
        ></div>
      </HideFor>
      <HideFor desktop desktopLargeUp desktopMedium>
        <div
          className={cn("menu-overlay-norad", {
            "menu-overlay-norad--show": showMobile,
            "menu-overlay-norad--initialized": initialized,
          })}
        ></div>
      </HideFor>
    </>
  );
};

export default MenuOverlay;
